import React, { useState, useEffect } from "react";
import { ButtonGroup } from "@mui/material";
import { SFTypography, SFStack, SFButton, SFUseStyled } from "@sf-core";
import { baseContainer } from "@base-provider";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useAuth0 } from "@auth0/auth0-react";
import _ from "lodash";
import { ReactComponent as EyLogo } from "./images/logo.svg";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(({ theme }) => ({
  width: "90%",
}));

const SFButtonStyled = styled(SFButton)(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: "space-between",
  textAlign: "left",
}));

const TenantForm = ({ onSelect }) => {
  const { t } = useTranslation();

  const { user } = useAuth0();
  let displayUserName = user.name ? user.name.split(" ")[0] : user.username;

  const [tenants, setTenants] = useState({ loading: true });

  useEffect(() => {
    baseContainer.authenticationService.getTenants().then((r) => {
      setTenants(_.orderBy(r, ["name"]));
    });
  }, []);

  if (tenants.loading) return null;

  return (
    <SFStackStyled spacing={2}>
      <EyLogo />
      <SFTypography variant="body2bold">
        {t("tenantSelectionScreen.title", { name: displayUserName })}
      </SFTypography>
      <SFTypography variant="body2">
        {t("tenantSelectionScreen.subtitle")}
      </SFTypography>
      <ButtonGroup orientation="vertical" variant="text">
        {tenants.map((tenant) => (
          <SFButtonStyled
            key={tenant.name}
            variant="text"
            endIcon={<ArrowForwardIosIcon color="blue500" />}
            onClick={() => onSelect(tenant)}
          >
            <SFTypography variant="body2">{tenant.name}</SFTypography>
          </SFButtonStyled>
        ))}
      </ButtonGroup>
    </SFStackStyled>
  );
};

export default TenantForm;
